import Listen from "@/Pages/Listen";
import Booking from "@/Pages/Booking";
import Profile from "@/Pages/Profile";
import Changepassword from "@/Pages/Changepassword";
import EditListing from "@/Pages/EditListing";
// import Messages from "@/Pages/Message";
import AddListing from "@/Pages/AddListing";
import About from "@/Pages/About";
import Favorite from "@/Pages/Favorite";
import MyDetails from "@/Pages/MyDetails";
import Invoice from "@/Pages/Invoice";
import BookingD from "@/Pages/BookingD";
import Wallet from "@/Pages/Wallet";
import Payout from "@/Pages/Payout";
import PayoutDetails from "@/Pages/PayoutDetails";
import Request from "@/Pages/Request";
import Login from "@/Pages/Login";
import Contact from "@/Pages/Contact";
import State from "@/Pages/State";
import StateDetail from "@/Pages/StateDetail";
import ApartmentDetail from "@/Pages/ApartmentDetail";
import BySpace from "@/Pages/BySpace";
import Squawks from "@/Pages/Squawks";
import MostFun from "@/Pages/StaticPages/MostFun";
import BusinessDetailPage from "@/fragments/business-detail";
import BusinessQR from "@/fragments/business-qr";
import TermService from "@/Pages/term/TermService";
import Privacy from "@/Pages/term/Privacy";
import Gallery from "@/Pages/Gallery";
import Testimonials from "@/Pages/Testimonials";
import Mostpopular from "@/Pages/StaticPages/Mostpopular";
import AirparkCommunities from "@/Pages/StaticPages/AirparkCommunities";
import InovatedIdea from "@/Pages/StaticPages/InovatedIdea";
import PackingListLadies from "@/Pages/StaticPages/PackingListladies";
import PicProfile from "@/Pages/PicProfile";
import Bannerthree from "@/Components/Bannerthree";
import Permission from "@/Pages/Permission";
import BigMap from "@/Pages/BigMap";
import PhilanthropyPage from "@/Pages/PhilanthropyPage";
import SquawksDetail from "@/Pages/SquawksDetail";
import FAQ from "@/Pages/FAQ";
import ShortTermRental from "@/Pages/StaticPages/ShortTermRental";
import Compare from "@/Pages/Compare";
import Trips from "@/Pages/Trips";
import BookingView from "@/Pages/BookingView";
import MyTrip from "@/Pages/MyTrip";
import Review from "@/Pages/Review";
import { ResetPassword } from "@/Pages";
import {
  CirtPolicy,
  ContentAndCopyrightPolicy,
  FairHousingPolicy,
  NeighborhoodNuisancePolicy,
  OffThePlatFormFeePolicy,
  ServiceFeePolicy,
  TrademarkPolicy,
} from "@/Pages/StaticPages/Agreements";
import { VerifyAccount } from "@/Components/Authentication/VerifyAccount";
import { PaymentSuccessPage } from "@/Pages/accounts/payments/PaymentMaethodSuccess";
import {
  DetailsFragment,
  MapListingFragment,
  PaymentFragment,
  BookingStatusFragment,
  RestaurantsFragment,
  MyListingsFragment,
  FeaturedStatusFragment,
  UserChats,
  AllBusinesses,
  AddBusinesses,
} from "@/fragments";
import { lazy, startTransition } from "react";
import FlightPlanViewer from "@/Pages/FlightPlanViewer";
import Advertise from "@/Pages/Advertise";
import { BusinessFragment } from "@/fragments/business";
import BusinessMarketPlace from "@/fragments/business-marketplace";
import AddListingAdmin from "@/Pages/AddListingAdmin";
import EditListingAdmin from "@/Pages/EditListingAdmin";

// Utility function to wrap lazy imports in startTransition
const lazyWithTransition = (importFunc) => {
  return lazy(
    () =>
      new Promise((resolve) => {
        startTransition(() => {
          resolve(importFunc());
        });
      })
  );
};

const Home = lazyWithTransition(() => import("@/Pages/Home"));
const Listing = lazyWithTransition(() => import("@/Pages/Listing"));
export const routes = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/business-qr/:id", element: <BusinessQR /> },
  { path: "/business/:type/:id", element: <BusinessDetailPage /> },
  { path: "/directory", element: <BusinessMarketPlace /> },
  { path: "/business/:type", element: <BusinessFragment /> },
  { path: "/addBusiness/:id", element: <AddBusinesses /> },
  { path: "/flight-plan", element: <FlightPlanViewer /> },
  { path: "/verify", element: <VerifyAccount /> },
  { path: "/advertise", element: <Advertise /> },
  { path: "/business", element: <AllBusinesses /> },
  { path: "/addbusiness", element: <AddBusinesses /> },
  { path: "/map/:id", element: <Bannerthree /> },
  { path: "/map_listing/:name/:key", element: <MapListingFragment /> },
  { path: "/map", element: <Bannerthree /> },
  { path: "/bigmap", element: <BigMap /> },
  { path: "/terms-of-service", element: <TermService /> },
  { path: "/compare", element: <Compare /> },
  { path: "/privacy_policy", element: <Privacy /> },
  { path: "/short-term-rental-insurance", element: <ShortTermRental /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/the-most-fun-fly-ins-in-america", element: <MostFun /> },
  {
    path: "/most-popular-air-shows-in-the-united-states",
    element: <Mostpopular />,
  },
  { path: "/airpark-communities-in-the-usa", element: <AirparkCommunities /> },
  { path: "/innovative-ideas-for-a-hangar-home", element: <InovatedIdea /> },
  {
    path: "/ultimate-travel-packing-list-for-ladies",
    element: <PackingListLadies />,
  },
  { path: "/about", element: <About /> },
  { path: "/listing", element: <Listing /> },
  { path: "/squawks", element: <Squawks /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/squawks/:id", element: <SquawksDetail /> },
  { path: "/philanthropy", element: <PhilanthropyPage /> },
  { path: "/dashboard", element: <Listen /> },
  { path: "/booking", element: <Booking /> },
  { path: "/booking_view", element: <BookingView /> },
  { path: "/trip_view", element: <MyTrip /> },
  { path: "/booking_details", element: <MyTrip /> },
  { path: "/trip", element: <Trips /> },
  { path: "/my_listing", element: <MyListingsFragment /> },
  { path: "/invoice_details", element: <BookingD /> },
  { path: "/my_wallets", element: <Wallet /> },
  { path: "/payout", element: <Payout /> },
  { path: "/request", element: <Request /> },
  { path: "/payoutdetails", element: <PayoutDetails /> },
  { path: "/favorite", element: <Favorite /> },
  { path: "/invoice", element: <Invoice /> },
  { path: "/review", element: <Review /> },
  { path: "/addlisting", element: <AddListing /> },
  { path: "/add_listing", element: <AddListingAdmin /> },
  { path: "/edit_listing/:id", element: <EditListingAdmin /> },
  { path: "/profile", element: <Profile /> },
  { path: "/agreements", element: <Permission /> },
  { path: "/user-profile", element: <PicProfile /> },
  {
    path: "/air_mail/:booking_id",
    element: <UserChats />,
  },
  {
    path: "/air_mail",
    element: <UserChats />,
  },
  { path: "/listing/:id", element: <DetailsFragment /> },
  { path: "/detail-my-listing/:id", element: <MyDetails /> },
  { path: "/EditListing/:id", element: <EditListing /> },
  { path: "/changepassword", element: <Changepassword /> },
  { path: "/contact", element: <Contact /> },
  { path: "/by-state-airport", element: <State /> },
  { path: "/by-state-airport/detail/:location", element: <StateDetail /> },
  { path: "/by-dwelling/details/:location", element: <ApartmentDetail /> },
  { path: "/by-space/details/:location", element: <BySpace /> },
  { path: "/account-settings/password", element: <ResetPassword /> },
  { path: "/account-settings/payments", element: <PaymentFragment /> },
  {
    path: "/account-settings/payments-success",
    element: <PaymentSuccessPage />,
  },
  { path: "/listing-status", element: <FeaturedStatusFragment /> },
  { path: "/booking-status", element: <BookingStatusFragment /> },
  { path: "/:type", element: <RestaurantsFragment /> },
  { path: "/cirt-policy", element: <CirtPolicy /> },
  { path: "/fair-housing-policy", element: <FairHousingPolicy /> },
  { path: "/trademark-policy", element: <TrademarkPolicy /> },
  {
    path: "/content-and-copyright-policy",
    element: <ContentAndCopyrightPolicy />,
  },
  {
    path: "/neighborhood-nuisance-and-disruptive-behavior-policy",
    element: <NeighborhoodNuisancePolicy />,
  },
  {
    path: "/off-the-platform-fees-policy",
    element: <OffThePlatFormFeePolicy />,
  },
  { path: "/service-fees-policy", element: <ServiceFeePolicy /> },
];
